import { useTranslation } from 'react-i18next';
import SystemStatus from '@libs/SystemStatus';
import useStatusFilter, {
  ButtonFilter as ButtonFilterConst,
} from '@pages/sharedHooks/useStatusFilter';

export const ButtonFilter = ButtonFilterConst;

const useStatusRestoreFilter = (onFilter) => {
  const { t } = useTranslation();
  const { listRestoreStatus } = SystemStatus;

  const listFilter = [
    {
      label: 'system_status.completed_text',
      status: listRestoreStatus.SUCCESS,
    },
    {
      label: 'system_status.running_text',
      status: listRestoreStatus.RUNNING,
    },
    {
      label: 'system_status.authentication_error_text',
      status: listRestoreStatus.AUTHENTICATION_ERROR,
    },
    {
      label: 'system_status.failed_text',
      status: listRestoreStatus.FAILED,
    },
  ];

  const headingText = t('status_restore_page.search_block.filter_by_restore_status_text');

  const {
    filterData,
    showDrawer,
    setShowDrawer,
    handleFilter,
    handleOpenDrawer,
    listBadges,
    handleDelete,
  } = useStatusFilter({ onFilter, listFilter, headingText });

  return {
    filterData,
    showDrawer,
    setShowDrawer,
    handleFilter,
    handleOpenDrawer,
    listBadges,
    handleDelete,
  };
};

export default useStatusRestoreFilter;
